// extracted by mini-css-extract-plugin
export var button = "_ns-2";
export var card = "_ns-0";
export var closeButtonContainer = "_ns-3";
export var iconContainer = "_ns-1";